import { debounce, onIdleOrFirstInteraction } from '../utils/utils';
import { metrics } from '@sentry/browser';

const loadJS = function (url, idParam, dataParam, location, loadPreviewBanner, callback) {
  const scriptTag = document.createElement('script');
  if (typeof callback === 'function') {
    scriptTag.onload = callback;
  }
  if (loadPreviewBanner) {
    scriptTag.setAttribute('data-draft', 'true');
  }
  scriptTag.src = url;
  scriptTag.id = idParam;
  scriptTag.setAttribute('data-settings-id', dataParam);
  scriptTag.type = 'application/javascript';
  scriptTag.defer = 'defer';
  /*const noncedTag = document.querySelector('[nonce]');
  if (noncedTag && noncedTag.nonce) {
    scriptTag.nonce = noncedTag.nonce;
  }*/
  location.appendChild(scriptTag);
};

export function loaduc(isTestEnv) {
  loadJS('https://web.cmp.usercentrics.eu/ui/loader.js', 'usercentrics-cmp', '2Jwm6l8a', document.head, isTestEnv, () => {
    window.dispatchEvent(new CustomEvent('ucLoaded'));
  });
  window.addEventListener('ucLoaded', async e => {
    // set styles to redesign the CMP prompt to fit ottonovas CD
    const ucStyle = document.createElement('style');
    ucStyle.innerHTML =
      '.cmp-wrapper .main-wrapper{line-height:1.5}header #uc-privacy-title{font-size:18px;color:#223254;}header .uc-img-wrapper{display:flex;justify-content:center;height:120px;overflow:hidden;border-radius:6px;background-color:var(--sec-light-05);border:1px solid var(--border-light);margin-bottom:16px;}header img.logo {height:220px!important;max-height:220px!important;}footer button#more{border: 1px solid var(--primary)}footer{padding-bottom:var(--spacing-xl)!important}footer .poweredBy{display:none!important}@media (min-width:769px){.cmp-wrapper .main-wrapper{line-height:1.3;font-size:14px}footer .buttons{font-size:15px}footer .buttons-row:first-child{grid-column-start:1;grid-column-end:3}}@media (min-width:992px){.cmp-wrapper, .cmp-wrapper .cmp{max-width: 870px!important;overflow-y:auto!important;}.cmp-wrapper .cmp{display:grid!important;grid-template-columns: 30% auto;grid-gap:28px;padding:24px;}header .uc-img-wrapper{grid-row:span 2;width:auto;height:auto;margin-bottom:0;display:flex;align-items:center;justify-content:center;border:none;}.cmp-wrapper .main-wrapper, .cmp-wrapper .main-wrapper header{display:contents;}.cmp-wrapper .actions.right{display:none!important;}header img.logo{height:240px!important;max-height:240px!important;margin:0!important;}header #uc-privacy-title{font-size:24px;}.privacy-text-detailed p{margin:0!important;}.cmp-wrapper footer{grid-column:2/-1;padding:0!important;}}';

    function applyCustomUcJs() {
      const ucShadowRoot = document.getElementById('usercentrics-cmp-ui').shadowRoot;
      const img = ucShadowRoot.querySelector('img.logo');
      if (!img || !img.parentNode) {
        return;
      }
      const wrapper = document.createElement('div');
      wrapper.classList.add('uc-img-wrapper');
      img.parentNode.insertBefore(wrapper, img);
      wrapper.appendChild(img);
    }

    function initCustomStyles() {
      const ucContainer = document.getElementById('usercentrics-cmp-ui');
      if (!ucContainer || !ucContainer.shadowRoot) {
        return;
      }

      applyCustomUcJs();
      ucContainer.shadowRoot.prepend(ucStyle);
      window.addEventListener(
        'resize',
        debounce(() => {
          if (!ucContainer.shadowRoot.querySelector('.main-wrapper > header >.uc-img-wrapper')) {
            applyCustomUcJs();
            ucContainer.shadowRoot.prepend(ucStyle);
          }
        }, 500)
      );
    }

    function initConsentTracking() {
      const ucContainer = document.getElementById('usercentrics-cmp-ui');
      if (!ucContainer || !ucContainer.shadowRoot || ucContainer.shadowRoot.dataset.trackingBound) {
        return;
      }
      ucContainer.shadowRoot.dataset.trackingBound = 'true';
      metrics.count('consultation.consent_banner_init', 1, {
        attributes: {
          metric_source: 'usercentrics-cmp',
          user_agent: navigator.userAgent,
          uri: window.location.href
        }
      });
      ucContainer.shadowRoot.addEventListener('click', clickEvent => {
        const target = clickEvent.target.closest('button, a');
        if (!target) {
          return;
        }
        metrics.count('consultation.consent_banner_click', 1, {
          attributes: {
            uc_element: target.id || target.className || target.tagName,
            uc_text: target.textContent?.trim().slice(0, 100),
            metric_source: 'usercentrics-cmp',
            user_agent: navigator.userAgent,
            uri: window.location.href
          }
        });
      });
    }

    if (window.__ucCmp && (await window.__ucCmp.isInitialized())) {
      //...if the shadowroot is already there
      initCustomStyles();
      initConsentTracking();
    } else {
      window.addEventListener('UC_UI_INITIALIZED', function (e) {
        //...if it is not there, apply an event listenter
        initCustomStyles();
        initConsentTracking();
      });
    }
  });
}

if (
  window.location.search.indexOf('mobile=1') > 0 ||
  onAppCall ||
  (window.location.href.indexOf('ottonova.de') < 0 && window.location.href.indexOf('loaduc=1') < 0 && sessionStorage.getItem('loaduc') !== 'true')
) {
  console.log('CMP not loaded.');
} else {
  if (window.location.href.indexOf('ottonova.de') < 0) {
    sessionStorage.setItem('loaduc', 'true');
  }
  const isTestEnv = window.location.href.indexOf('test.on.ag') > 0 || window.location.href.indexOf('localhost') > 0;
  onIdleOrFirstInteraction(() => loaduc(isTestEnv));
}
